import React, { useState } from 'react'
import Namespace from 'src/constants/locale/Namespace'
import SmsConfigurationKeys from 'src/constants/locale/key/SmsConfiguration'
import { Grid, Card, Typography } from '@material-ui/core'
import { components, DataFlattener, DateTimeFormatter, useTranslation } from 'cng-web-lib'
import makeValidationSchema from './MakeValidationSchema'
import SmsConfigurationWhiteLabelGroupFormProperties from './SmsConfigurationWhiteLabelGroupFormProperties'
import { useFormContext } from 'react-hook-form'
import CngSection from '../../components/cngcomponents/CngSection'
import LocalTable from '../../components/aciacehighway/LocalTable'
import DialogForm from '../../components/aciacehighway/DialogForm'
import AlertDialog from '../../components/aciacehighway/AlertDialog'

const {
  form: {
    field: {
      CngTextField,
      CngDateField,
      CngSwitchField,
    },
  },
  CngGridItem
} = components

const DEFAULT_INITIAL_VALUES = Object.freeze({
  id: "",
  content: "",
  startDate: "",
  endDate: "",
  priority: "0",
  active: true,
  createdBy: "",
  createdDate: "",
  updatedBy: "",
  updatedDate: "",
  version: "",
  smsConfigurationWhiteLabelGroup: [],
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  makeValidationSchema: makeValidationSchema
}

function Fields({ disabled, isView, shouldHideMap }) {
  const [formDialog, setFormDialog] = useState({ open: false, whiteLabelGroup: null })
  const [confirmDialog, setConfirmDialog] = useState({ open: false, whiteLabelGroup: null })
  const { getValues, setValue, watch } = useFormContext()
  const smsConfigurationWhiteLabelGroup = watch('smsConfigurationWhiteLabelGroup')
  const { translate } = useTranslation(Namespace.SMS_CONFIGURATION)
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let smsConfiguration = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.TITLE
    )
    let content = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.CONTENT
    )
    let startDate = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.START_DATE
    )
    let endDate = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.END_DATE
    )
    let priority = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.PRIORITY
    )
    let active = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.ACTIVE
    )
    let smsConfigurationWhiteLabelGroup = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.SmsConfigurationWhiteLabelGroup.TITLE
    )
    let whiteLabelGroup = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.SmsConfigurationWhiteLabelGroup.WHITE_LABEL_GROUP
    )
    let addWhiteLabelGroup = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.ADD_WHITE_LABEL_GROUP
    )
    let editWhiteLabelGroup = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.EDIT_WHITE_LABEL_GROUP
    )
    let addNewWhiteLabelGroup = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.ADD_NEW_WHITE_LABEL_GROUP
    )
    let editButton = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.EDIT_BUTTON
    )
    let deleteButton = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.DELETE_BUTTON
    )
    let deleteContent = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.DELETE_CONTENT
    )
    let cancelDeleteButton = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.CANCEL_DELETE_BUTTON
    )
    let confirmDeleteButton = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.CONFIRM_DELETE_BUTTON
    )

    return {
      smsConfiguration,
      content,
      startDate,
      endDate,
      priority,
      active,
      smsConfigurationWhiteLabelGroup,
      whiteLabelGroup,
      addWhiteLabelGroup,
      editWhiteLabelGroup,
      addNewWhiteLabelGroup,
      editButton,
      deleteButton,
      deleteContent,
      cancelDeleteButton,
      confirmDeleteButton,
    }
  }

  function handleAddWhiteLabelGroup(data) {
    const updated = [...getValues('smsConfigurationWhiteLabelGroup'), data]
    setValue('smsConfigurationWhiteLabelGroup', updated)
    setFormDialog({ open: false, whiteLabelGroup: null })
  }

  function handleDeleteWhiteLabelGroup() {
    if (!confirmDialog.whiteLabelGroup) return

    const updated = [...getValues('smsConfigurationWhiteLabelGroup')].filter(
      (group) => group._id !== confirmDialog.whiteLabelGroup._id
    )

    setValue('smsConfigurationWhiteLabelGroup', updated)
    setConfirmDialog({ open: false, whiteLabelGroup: null })
  }

  function handleEditWhiteLabelGroup(data) {
    const updated = [...getValues('smsConfigurationWhiteLabelGroup')]
    const index = updated.findIndex((group) => group._id === data._id)

    updated[index] = data

    setValue('smsConfigurationWhiteLabelGroup', updated)
    setFormDialog({ open: false, whiteLabelGroup: null })
  }

  return (
    <>
      <CngSection title={translatedTextsObject.smsConfiguration}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <CngGridItem xs={12} shouldHide={shouldHideMap?.content}>
                <CngTextField
                  name="content"
                  label={translatedTextsObject.content}
                  disabled={disabled}
                  isRequired
                  multiline
                  rows={10}
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap?.startDate}>
                <CngDateField
                  name="startDate"
                  label={translatedTextsObject.startDate}
                  isRequired
                  disabled={disabled}
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap?.endDate}>
                <CngDateField
                  name="endDate"
                  label={translatedTextsObject.endDate}
                  isRequired
                  disabled={disabled}
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap?.priority}>
                <CngTextField
                  name="priority"
                  label={translatedTextsObject.priority}
                  isRequired
                  disabled={disabled}
                  type="numeric"
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap?.active}>
                <CngSwitchField
                  name="active"
                  label={translatedTextsObject.active}
                  disabled={disabled}
                />
              </CngGridItem>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Card variant='outlined'>
              <LocalTable
                columns={[
                  {
                    field: 'whiteLabelGroup',
                    title: translatedTextsObject.whiteLabelGroup
                  }
                ]}
                data={smsConfigurationWhiteLabelGroup}
                header={
                  <Typography style={{ fontWeight: 600 }}>
                    {translatedTextsObject.smsConfigurationWhiteLabelGroup}
                  </Typography>
                }
                {...(!isView && {
                  actions: [
                    {
                      color: 'primary',
                      buttonProps: { color: 'secondary' },
                      label: translatedTextsObject.addWhiteLabelGroup,
                      icon: ['fal', 'plus-circle'],
                      onClick: () => setFormDialog({ open: true, whiteLabelGroup: null })
                    }
                  ],
                  rowActions: [
                    {
                      icon: ['fal', 'pen'],
                      onClick: (rowData) =>
                        setFormDialog({ open: true, whiteLabelGroup: rowData }),
                      tooltip: translatedTextsObject.editButton
                    },
                    {
                      icon: ['fal', 'trash'],
                      onClick: (rowData) =>
                        setConfirmDialog({ open: true, whiteLabelGroup: rowData }),
                      tooltip: translatedTextsObject.deleteButton
                    }
                  ]
                })}
              />
            </Card>
          </Grid>
        </Grid>
      </CngSection>
      <DialogForm
        formProperties={SmsConfigurationWhiteLabelGroupFormProperties}
        fullWidth
        isView={isView}
        maxWidth='md'
        open={formDialog.open}
        onClose={() => setFormDialog({ open: false, whiteLabelGroup: null })}
        onSubmit={
          formDialog.whiteLabelGroup
            ? handleEditWhiteLabelGroup
            : handleAddWhiteLabelGroup
        }
        title={formDialog.whiteLabelGroup ? translatedTextsObject.editWhiteLabelGroup : translatedTextsObject.addNewWhiteLabelGroup}
        value={formDialog.whiteLabelGroup}
      />
      <AlertDialog
        cancelLabel={translatedTextsObject.cancelDeleteButton}
        confirmLabel={translatedTextsObject.confirmDeleteButton}
        open={confirmDialog.open}
        onClose={() => setConfirmDialog({ open: false, whiteLabelGroup: null })}
        onCancel={() => setConfirmDialog({ open: false, whiteLabelGroup: null })}
        onConfirm={handleDeleteWhiteLabelGroup}
        title={translatedTextsObject.deleteButton}
      >
        {translatedTextsObject.deleteContent}
      </AlertDialog>
    </>
  )
}

function toClientDataFormat(serverData) {
  let localData = { ...serverData }

  localData.smsConfigurationWhiteLabelGroup.forEach((group, index) => {
    group['_id'] = index
  })

  localData.startDate = DateTimeFormatter.toClientDate(localData.startDate)
  localData.endDate = DateTimeFormatter.toClientDate(localData.endDate)
  localData.createdDate = DateTimeFormatter.toClientDate(localData.createdDate)
  localData.updatedDate = DateTimeFormatter.toClientDate(localData.updatedDate)

  return localData
}

function toServerDataFormat(localData) {
  localData.startDate = DateTimeFormatter.toServerDate(localData.startDate)
  localData.endDate = DateTimeFormatter.toServerDate(localData.endDate)
  localData.createdDate = DateTimeFormatter.toServerDate(localData.createdDate)
  localData.updatedDate = DateTimeFormatter.toServerDate(localData.updatedDate)

  return DataFlattener.unflatten(localData)
}

const FormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields,
  toClientDataFormat: toClientDataFormat,
  toServerDataFormat: toServerDataFormat
})

export default FormProperties
